var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

import merge from 'deepmerge';
import configureTooltip from '../tooltip/main';

var buildHeatmapConfiguration = function buildHeatmapConfiguration(heatmapConfig, seriesConfig, seriesDataObj, customConfig) {
    var seriesType = 'heatmap';
    var CurrencySymbol = seriesConfig.CurrencySymbol,
        ValueFormat = seriesConfig.ValueFormat;

    var seriesDatalength = seriesDataObj.length;

    var HEATMAP_XAXIS = {
        categories: []
    };

    var HEATMAP_YAXIS = {
        categories: []
    };

    var xAxisCategory = new Set();
    var yAxisCategory = new Set();
    var tooltipConfigs = seriesConfig.Tooltip.TooltipConfigs;
    var tooltipConfigLength = tooltipConfigs.length;

    for (var index = 0; index < seriesDatalength; index++) {
        xAxisCategory.add(seriesDataObj[index][heatmapConfig.RowField]);
        yAxisCategory.add(seriesDataObj[index][heatmapConfig.ColumnField]);
    }

    HEATMAP_XAXIS.categories = [].concat(xAxisCategory);
    HEATMAP_YAXIS.categories = [].concat(yAxisCategory);

    var xAxisLength = HEATMAP_XAXIS.categories[0].size;
    var yAxisLength = HEATMAP_YAXIS.categories[0].size;
    var yAxis = Array.from(HEATMAP_YAXIS.categories[0]);
    var xAxis = Array.from(HEATMAP_XAXIS.categories[0]);
    var xIndex = void 0,
        yIndex = void 0;
    var processedSeriesData = {};
    var data = [];
    var xAxisCategoryName = void 0,
        yAxisCategoryName = void 0;
    for (xIndex = 0; xIndex < xAxisLength; xIndex++) {
        xAxisCategoryName = xAxis[xIndex];
        for (yIndex = 0; yIndex < yAxisLength; yIndex++) {
            processedSeriesData = {};
            processedSeriesData['x'] = xIndex;
            processedSeriesData['y'] = yIndex;
            yAxisCategoryName = yAxis[yIndex];
            var cellData = null;

            if (seriesDataObj) cellData = seriesDataObj.filter(function (f) {
                return f[heatmapConfig.ColumnField] == yAxisCategoryName && f[heatmapConfig.RowField] == xAxisCategoryName;
            });

            if (cellData && cellData.length > 0) {
                processedSeriesData['value'] = cellData[0][heatmapConfig.ValueField];
                processedSeriesData['name'] = cellData[0][heatmapConfig.ColumnField];
                processedSeriesData['category'] = cellData[0][heatmapConfig.RowField];
                if (tooltipConfigs !== null && tooltipConfigLength > 0) {

                    for (var dataIndex = 0; dataIndex < tooltipConfigLength; dataIndex++) {
                        processedSeriesData[tooltipConfigs[dataIndex].Id] = cellData[0].tooltip[tooltipConfigs[dataIndex].Id];
                    }
                }
            } else {
                processedSeriesData['value'] = 0;
                processedSeriesData['name'] = yAxisCategoryName;
                processedSeriesData['category'] = xAxisCategoryName;
            }
            data.push(processedSeriesData);
        }
    }

    return merge({
        data: data,
        borderWidth: 1,
        tooltip: configureTooltip(seriesType, _extends({}, seriesConfig, { ValueFormat: ValueFormat, CurrencySymbol: CurrencySymbol }))
    }, customConfig);
};

export default buildHeatmapConfiguration;